import React from 'react';

export const PartnerHero = [
	{
		id: 1,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 11,
				paragraph: [
					<p>
						Whether you are a stock broker or an investment distributor for
						financial products like Mutual Funds etc, you need a robust platform
						that can support the transactions of your clients and help you
						manage them flawlessly. This is where our expertise comes in. As an
						experienced financial services advisor and a fintech company, we
						offer comprehensive technology solutions and a suite of back-end
						services so you can entirely focus on your business growth.
					</p>,
					<p>
						We provide you with high-end technology that is reliable, scalable,
						and completely customizable. Whether you are an individual or an
						established entity, whether you operate from a central location or
						have customer touch points at multiple
					</p>,
				],
			},
			{
				id: 12,
				paragraph: [
					<p>
						locations, our tech platform can be customised to cater to your
						unique business needs. With the help of our technology, you can
						establish a chic digital identity for your business and thus attract
						more clients.
					</p>,
					<p>
						In addition to the above, our technology also offers high-end
						analytics for HNI portfolios. Our team of data scientists have
						developed systems and processes for automated portfolio reporting
						and investor profiling. Based on these systems, custom portfolio
						performance reports can be viewed, studied, and downloaded to
						present to clients for the right impact. Your portfolio management
						services will see a boost with our intelligent reporting.
					</p>,
				],
			},
		],
	},
];
